<template>
  <div class="tab-pane fade active show" id="real-time-content" role="tabpanel" aria-labelledby="real-time-content-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">遊客中心</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option v-for="(list, index) in peopleAnalysisScenicArea" :key="index" :value="list.id">{{list.name}}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk" :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV" :disabled="isWaitCCTVList"> 
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">即時</h1>
      <p class="mb-2 p-0">註：計算方式
        <br>(1) 各時段在園人數 = 累計至該時段進場 - 離場人數
        <br>(2) 統計在園人數 = 總計進場 - 總計離場人數</p>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="realTimeCenterPeople" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">遊客中心</th>
                    <th scope="col">在園人數</th>
                    <th scope="col">進場人數</th>
                    <th scope="col">離場人數</th>                    
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in peopleCountDataList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td style="white-space: pre-line;">{{ item.time }}</td>  <!-- style讓 \n可以換行-->
                    <td>{{ item.areaName}}</td>
                    <td>{{ item.peopleStay }}</td>
                    <td>{{ item.peopleIn}}</td>
                    <td>{{ item.peopleOut }}</td>
                    
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2 pt-md-4">
          <div id="realTimeCenterPeopleChart">
                      <apexchart
                        type="area"
                        height="200"
                        :options="sumPeopleFlowSetting"
                        :series="sumPeopleFlowData"
                      ></apexchart>
          </div>
        </div>
      </div>

    </div>
  </div>
    

  
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import { postCentralPeopleFlow } from '../../api/eastCoastDataApi/ElkQuery/PeopleFlowElk'
import ApexchartObject from '../../utils/apexchartObject/centerPeopleFlow'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      peopleCountDataList: [],
      isWaitCCTVList: false,
      sumPeopleFlowData:[],
      sumPeopleFlowSetting: ApexchartObject.realTimePeopleFlow,

      sumPeopleFlowHourData: [],
      sumPeopleFlowHourStayData: [],
      maxSelectTime: moment().startOf('m').toISOString(),

    };
  },
  watch: {
    async selectScenicAreaId() {
      // this.isWaitCCTVList = true
      // await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      // this.selectDeviceId = "-1"
      // this.isWaitCCTVList = false
    },
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', {scenicAreaList: 'allscenicArea'}),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


     peopleAnalysisScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE))
    },

    searchAreaName() {
      const area = this.scenicAreaList.find(s => s.id === this.selectScenicAreaId)
      return area ? area.name : ''
    },

    searchTime() {
      return `${moment(this.startTime).format('YYYY/MM/DD HH:mm')}~${moment(this.endTime).format('YYYY/MM/DD HH:mm')}`
    },
  },
  methods: {
    getTableAreaName(name) {
      if(Utils.isEmptyObject(name))
        return this.searchAreaName

      return name  
    },
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    async queryCSV() {
      const peopleCountDataList = await this.searchELK()
      if(Utils.isEmptyObject(peopleCountDataList)) {
        return
      }

      const csvContent = [['時間', '遊客中心', '在園人數', '進場人數', '離場人數']]
      peopleCountDataList.forEach(item => {
        const row = []
        row.push(item.time.replace(/\n/g, ' '))
        row.push(item.areaName)
        row.push(item.peopleStay)
        row.push(item.peopleIn)
        row.push(item.peopleOut)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_遊客人數統計.csv`
      exportCSV.genCSVFile(csvContent, fileName)
    },

    async queryElk () {
      this.peopleCountDataList = await this.searchELK()
      this.updateTable()
      this.setChartData(this.peopleCountDataList)
    },

    async searchELK() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      const condition = {
        areas:[],
        sttime: moment(this.startTime).startOf('minute').format(),
        endtime: moment(this.endTime).startOf('minute').format(),
        interval: "hour"
      }

      
      if(this.selectScenicAreaId === -1) {
        //全選
        this.peopleAnalysisScenicArea.forEach(e => {
          condition.areas.push(e.id)
        })
      }

      if(this.selectScenicAreaId > -1) {
        condition.areas.push(this.selectScenicAreaId)
      }

      const result = await postCentralPeopleFlow(condition)
      if(!result.success){
        return []
      }

      const total = {
        time: '統計',
        areaName: '',
        peopleIn: 0,
        peopleOut: 0,
        peopleStay: 0,

      }
      let realTotalPeopleStay = 0;// 以空值存入各時段實際在園人數
      let lastAreaId = null; // 儲存 areaID 的變數 (用於判斷是否為該景區最後一筆資料)

      const dataList = result.data.map(e => {
        const data ={};
        // console.log("e",e)

        if (lastAreaId !== e.areaId|| moment(e.dateTime).format('HH') === '00') {
          // 若為該景區第一筆資料或已換日，則將在園人數歸零
          console.log("歸零")
          realTotalPeopleStay = 0;
        } 

        // data.realTotalPeopleStay = [];  
        data.areaName = e.areaName;
        data.areaId = e.areaId;
        data.time = `${moment(e.dateTime).format('YYYY-MM-DD')}\n${moment(e.dateTime).format('HH')}~${moment(e.dateTime).add(1, 'h').format('HH')}`
        data.peopleIn = e.peopleIn // 進場人數
        data.peopleOut = e.peopleOut //離場人數
        data.realHourPeopleStay =  e.peopleIn - e.peopleOut  // 該時段進場-離場人數 (還原負值情況)
        realTotalPeopleStay = realTotalPeopleStay + data.realHourPeopleStay ; // 該時段實際在園人數 (還原負值情況 + 前時段進場-離場)
        data.realTotalpeopleStay = realTotalPeopleStay;
        
        // console.log("lastAreaId：",lastAreaId,";","e.areaId:",e.areaId);

        lastAreaId = e.areaId; // 更新 areaID  (用於判斷是否為該景區最後一筆資料)
        data.peopleStay =  realTotalPeopleStay <0 ?0: realTotalPeopleStay // 該時段在園人數 (負值情況顯示為 0)


        // console.log("e.peopleStay:",e.peopleStay);
        // console.log("realTotalPeopleStay",realTotalPeopleStay);
        // console.log("after-data.peopleStay:",data.peopleStay);
      
        data.dateTime = e.dateTime

   
        total.peopleIn = total.peopleIn + data.peopleIn
        total.peopleOut = total.peopleOut + data.peopleOut


        // console.log("data",data);
        return data
      })

      // console.log("real",realTotalPeopleStay);
      // realPeopleStay
      total.peopleStay = total.peopleIn - total.peopleOut < 0? 0 : total.peopleIn - total.peopleOut
      // console.log("total",total);
      dataList.push(total)
      // console.log("dataList",dataList);
      return dataList
    },

    setChartData(dataList){
      
      const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列
      // console.log("list ",list );
      

      this.sumPeopleFlowHourData = [];
      this.sumPeopleFlowHourStayData = []; //在園為主要顯示資料條
      // console.log("this.people",this.peopleAnalysisScenicArea)
      let searchArea = null;
      if(this.selectScenicAreaId === -1){
        searchArea = this.peopleAnalysisScenicArea;
      }else{
        searchArea = this.peopleAnalysisScenicArea.filter(e => e.id === this.selectScenicAreaId);
      }

      for(let i  = 0; i < searchArea.length; i++){
        // const data = list[i];
        const peopleStay = dataList
          .filter((d) => searchArea[i].id === d.areaId)
          .map((d) => d.peopleStay);

          // console.log("peopleStayCount",peopleStayCount);
          const peopleInCount = dataList
          .filter((d) => searchArea[i].id === d.areaId)
          .map((d) => d.peopleIn);

          const peopleOutCount = dataList
          .filter((d) => searchArea[i].id === d.areaId)
          .map((d) => d.peopleOut);


          this.sumPeopleFlowHourStayData.push({
            name: searchArea[i].name, 
            // data: [peopleStayCount,peopleInCount,peopleOutCount],
            data: peopleStay,
          })

          this.sumPeopleFlowHourData.push({
            name: searchArea[i].name, 
            // data: [peopleStayCount,peopleInCount,peopleOutCount],
            data: [peopleStay,peopleInCount,peopleOutCount],
          })
          

      }
      this.sumPeopleFlowData = this.sumPeopleFlowHourStayData;
      // console.log("this.sumPeopleFlowHourData", this.sumPeopleFlowHourData);
      const st = moment(this.startTime).startOf('minute').format();
      const et = moment(this.endTime).startOf('minute').format();
      const hours = (moment(et).diff(moment(st), 'hours')) +1; // 取得目前時間區間的總小時數

      const timestamps = Array.from({length: hours}, (v, i) => moment(st).add(i, 'hours').format()); 
      // console.log("aaaaaaaa",timestamps);
  
      // let xaxisCategories = moment(this.startTime).startOf('minute').format();
      let chartSetting = {...this.sumPeopleFlowSetting}
      chartSetting.xaxis.categories = timestamps;

      chartSetting.tooltip.x.formatter = function (val) {
        // console.log("val",val);
        let stDate = moment(val).format("MM/DD");
        let stHour = moment(val).format("HH");
        let endHour = moment(val).add(1, 'hours').format("HH");
        // let allpeopleInData = allData.data[1].date;//活動日期
        return ((stDate)+" "+(stHour)+ " ~ " +(endHour)+" 時")
      };

      let allData = this.sumPeopleFlowHourData;
      // console.log("allData",allData);
      chartSetting.tooltip.y.formatter = function (val,{ series, seriesIndex, dataPointIndex,w }) {

        let allpeopleInData = allData[seriesIndex].data[1][dataPointIndex]; // 進場人數
        let allpeopleOutCount = allData[seriesIndex].data[2][dataPointIndex]; // 離場人數
      //   // console.log( "ccc",allData[seriesIndex].data[1][dataPointIndex])

      return `
          【在園人數：${val} 人】
          【進場人數：${allpeopleInData}人】
          【離場人數：${allpeopleOutCount}人】
              `
      }

      this.sumPeopleFlowSetting = {...chartSetting};

    },

    // setChartData(dataList) {
    //   console.log("dataList",dataList);

    //   const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列
    //   // console.log("list", list);
    //   const sumList = Object.values(list.reduce((acc, obj) => {
    //     //將相同天數的人數相加
    //     if (acc[obj.time]) {
    //       acc[obj.time].peopleStay += obj.peopleStay;
    //       acc[obj.time].peopleIn += obj.peopleIn;
    //       acc[obj.time].peopleOut += obj.peopleOut;

    //     } else {
    //       acc[obj.time] = { ...obj };
    //     }
    //     return acc;
    //   }, {}));

    //   this.sumPeopleFlowData = []
    //   const peopleStayCount = sumList.map((d, i) => {
    //     return d.peopleStay
    //   })

    //   const peopleInCount = sumList.map((d, i) => {
    //     return d.peopleIn
    //   })

    //   const peopleOutCount = sumList.map((d, i) => {
    //     return d.peopleOut
    //   })

    //   this.sumPeopleFlowData.push({name: '在園人數', data: peopleStayCount})
    //   this.sumPeopleFlowData.push({name: '進場人數', data: peopleInCount})
    //   this.sumPeopleFlowData.push({name: '離場人數', data: peopleOutCount})

    //   let chartSetting = {...this.sumPeopleFlowSetting}

    //   // console.log("this.sumPeopleFlowData", this.sumPeopleFlowData)

    //   let xaxisCategories = sumList.map((d, i) => {
    //     const hour = moment(d.dateTime).format("HH:mm");
    //     const date = moment(d.dateTime).format("YYYY-MM-DD");
    //     const category = `${date} ${hour}`;
    //     return category
    //   })

    //   if(xaxisCategories.length === 1) {
    //     const data = Utils.setapexChartZero(xaxisCategories, this.sumPeopleFlowData)
    //     xaxisCategories = data.xaxisCategories
    //     this.sumPeopleFlowData = data.chartData
    //   }
    //   chartSetting.tooltip.x.formatter = function (val) {
    //     return `${moment(val).format("MM/DD HH")} - ${moment(val).add(1, 'hours').format("HH")} `;
    //   };
    //   chartSetting.xaxis.categories = xaxisCategories
    //   chartSetting.chart.toolbar.export={
    //           csv: {
    //             filename: `即時_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
    //           },
    //           svg: {
    //             filename: `即時_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
    //           },
    //           png: {
    //             filename: `即時_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
    //           }
    //         }
            
    //   this.sumPeopleFlowSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    // },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.time)) {
        return "-";
      }

      const time = moment(item.time)
      return `${time.format('HH')}~${time.add(1, 'h').format('HH')}`
    },

    initTable: function () {
      this.table = $("#realTimeCenterPeople").DataTable({
        aoColumns: [
          ...new Array($("#realTimeCenterPeople th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25,
      });
    },

    updateTable() {
      if(!Utils.isEmptyObject(this.table)){
        this.table.destroy()
      }
      
      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
  }
};
</script>
<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */


tbody>tr>td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

</style>
